import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faSquareFacebook } from "@fortawesome/free-brands-svg-icons";
import { faSquareTwitter } from "@fortawesome/free-brands-svg-icons";
import { faSquareWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { ShareService } from "ngx-sharebuttons";
import { ShareButton } from "ngx-sharebuttons/button";
import { ToastrService } from "ngx-toastr";
import { API_ROUTES } from "src/app/core/_constants/api-route.constant";
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
import { LocalStorageProvider } from "src/app/services/storage/storage.service";
// import { FirebaseDynamicLinks } from 'firebase-dynamic-links';

@Component({
  selector: "app-share",
  templateUrl: "./share.component.html",
  styleUrls: ["./share.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ShareComponent implements OnInit {
  // firebaseDynamicLinks = new FirebaseDynamicLinks("AIzaSyBjt18h_2tJEdEyTKfaHxDjD3Kymc4XtL0");
  fbBtn = faSquareFacebook;
  wappBtn = faSquareWhatsapp;
  twtBtn = faSquareTwitter;
  linkedbtn = faLinkedinIn;
  fbmessangerbtn = faFacebookMessenger;
  copybtn = faCopy;
  url: any;
  shortLink: any;
  title: any;
  authId: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: ApiServicesService,
    private toastr: ToastrService,
    private storageService: LocalStorageProvider
  ) {}

  ngOnInit() {
    this.authId = this.storageService.getItem("UserId");
    let origin = window.location.origin;
    // let url = "https://devweb.raftaarr.com/76UZ?";
    let url = window.location.href;
    let image = this.data.data.Media.find((element: any) =>
      element.media_type.toLowerCase().includes("image")
    );
    let description: any;
    if (this.data.type == 1 || this.data.type == "1") {
      // post share from home page
      // this.url = url + "/post_id=" + this.data.id;
      this.url = url + "/post-detail?post_id=" + this.data.id;

      description = this.data.data.content;
      this.title = "Check this Post";
      // this.shortLink();
      // let param = {
      //   key: "AIzaSyBjt18h_2tJEdEyTKfaHxDjD3Kymc4XtL0"
      // }
      // let payload = {
      //   "dynamicLinkInfo": {
      //     "domainUriPrefix": "https://firebase.raftaarr.com",
      //     "link": this.url,
      //     "androidInfo": {
      //       "androidPackageName": "com.raftaarr",
      //       "androidFallbackLink": "https://play.google.com/store/apps/details?id=com.ludo.king"
      //     },
      //     "iosInfo": {
      //       "iosBundleId": "com.raftaarr.app",
      //       "iosFallbackLink": "https://apps.apple.com/us/app/bentley-mulliner/id1601484578",
      //       "iosAppStoreId": "6443399745"
      //     },
      //     "socialMetaTagInfo": {
      //       "socialTitle": "Test01",
      //       "socialDescription": this.data.data.content,
      //       "socialImageLink": "https://srv4.imgonline.com.ua/result_img/imgonline-com-ua-resize-Vf9xwnW4Lt.jpg"
      //     }
      //   },
      //   "suffix": {
      //     "option": "SHORT"
      //   }
      // }

      // this.url = 'https://www.google.co.in/'
    } else if (this.data.type == 2) {
      // req share from home page
      // this.url = url + "/requirement_id=" + this.data.id;

      if (url.includes("/more/saved")) {
        let newUrl=url.split('/')
        var modifiedComponents = newUrl.filter(function (component) {
          return component !== 'more' && component !== 'saved';
        });

        var modifiedUrl = modifiedComponents.join('/');


        this.url = modifiedUrl + "/home/manufacturing-o-r_home?id=" + this.data.id;

      } else this.url = url + "/manufacturing-o-r_home?id=" + this.data.id;

      description = this.data.data.description;
      this.title = "Check this Requirement";
    } else if (this.data.type == 3) {
      // this.url = url + "/product_id=" + this.data.id;
      this.url = url;
      description = this.data.data.description;
      this.title = "Check this Product";
    } else if (this.data.type == 4) {
      // share feature product

      // this.url = url + "/product_detail=" + this.data.id;
      this.url = url;
      description = this.data.data.description;
      this.title = "Check this Product";
    } else if (this.data.type == 5) {
      // share link of my profile
      this.url = url;
      // this.url = url + "/project_detail=" + this.data.id;
      // this.url = url + "/project_detail=" + this.data.id;+ "?my_id=" + this.authId;
      description = this.data.data.description;
      this.title = "Check this project";
    } else if (this.data.type == 6) {
      // ask for testimonial from my project
      // this.url = url + "/project_id=" + this.data.id + "?my_id=" + this.authId;
      // this.url = url  + "?my_id=" + this.authId;
      this.url = url;
      description = this.data.data.description;
      this.title = "Rate this project";
    }

    let payload = {
      link: this.url,
      socialTitle: this.title,
      socialDescription: description,
      socialImageLink: image?.url
        ? image.url
        : "https://raftaar-dev.s3.ap-south-1.amazonaws.com/Group%201000006538.png",
    };

    // this.service
    //   .post(payload, API_ROUTES.Home.externalShareLink, {})
    //   .pipe()
    //   .subscribe(
    //     (res) => {
    //       let json = JSON.parse(res.body);
    //       this.shortLink = json.shortLink;
    //     },
    //     (error) => {
    //       this.shortLink = "";
    //     }
      // );
    //   this.share.addButton('customButton', {
    //     type: 'customButton',
    //     text: 'My Custom Button',
    //     icon: ['fas', 'fas-comments-dollar'],
    //     params: {
    //       // define the needed parameters here
    //     },
    //     // If the button uses a custom function, then set your custom function
    //     func: () => {
    //     }
    //   });
    //   this.shareButtons.addButton('sms', {
    //     type: 'sms',
    //     text: 'SMS',
    //     icon: 'fas fa-comment-alt',
    //     color: '#7F1E3B',
    //     share: {
    //       desktop: 'sharerLink',
    //       metaTags: {
    //         url: 'paramNameForURL'
    //       },
    //       operators: [
    //         urlInMessageOperator,
    //         metaTagsOperator
    //       ]
    //     }
    //   });
    // }
  }

  copy() {
    this.toastr.success("Copied");
  }

  //  async shortLink(){
  //   let link = await this.firebaseDynamicLinks.createLink({
  //     "dynamicLinkInfo": {
  //       "domainUriPrefix": "https://firebase.raftaarr.com",
  //       "link": "http://web.raftaarr.com/jdF1?product_id=44df3752-c75b-4a51-a7cd-4e0bfb683f90",
  //       "androidInfo": {
  //         "androidPackageName": "com.raftaarr",
  //         "androidFallbackLink": "https://play.google.com/store/apps/details?id=com.ludo.king"
  //       },
  //       "iosInfo": {
  //         "iosBundleId": "com.raftaarr.app",
  //         "iosFallbackLink": "https://apps.apple.com/us/app/bentley-mulliner/id1601484578",
  //         "iosAppStoreId": "6443399745"
  //       },
  //       "socialMetaTagInfo": {
  //         "socialTitle": "Test01",
  //         "socialDescription": "post",
  //         "socialImageLink": "https://srv4.imgonline.com.ua/result_img/imgonline-com-ua-resize-Vf9xwnW4Lt.jpg"
  //       }
  //     },
  //     "suffix": {
  //       "option": "SHORT"
  //     }
  //   });

  //

  //  }
}
